<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogauc.vue
*@ 컴포넌트설명 :[인도] 예금 상품 > 금리 안내(개인)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6>
        {{ /*정기예금*/ $t("MDEP-01-02-01-30") }}
        <required />
      </h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type02">
      <colgroup>
        <col width="30%" />
        <col width="50%" />
        <col />
      </colgroup>
      <tbody>
        <template v-if="lnag == $config.LANG_KOR">
          <tr>
            <th scope="row" rowspan="12">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">7 - 14 일</th>
            <td>2.80%</td>
          </tr>
          <tr>
            <th scope="row">15 -30 일</th>
            <td>3.00%</td>
          </tr>
          <tr>
            <th scope="row">31 - 45 일</th>
            <td>4.00%</td>
          </tr>
          <tr>
            <th scope="row">46 - 60 일</th>
            <td>4.00%</td>
          </tr>
          <tr>
            <th scope="row">61 - 91 일</th>
            <td>4.25%</td>
          </tr>
          <tr>
            <th scope="row">92 - 182 일</th>
            <td>4.50%</td>
          </tr>
          <tr>
            <th scope="row">183 - 273 일</th>
            <td>4.50%</td>
          </tr>
          <tr>
            <th scope="row">274 일 - 1 년 미만</th>
            <td>4.75</td>
          </tr>
          <tr>
            <th scope="row">1 년 - 2 년미만</th>
            <td>5.25</td>
          </tr>
          <tr>
            <th scope="row">2 년 - 3 년미만</th>
            <td>5.50</td>
          </tr>
          <tr>
            <th scope="row">3 년 - 5 년미만</th>
            <td>5.50</td>
          </tr>
          <tr>
            <th scope="row">5 년 - 10 년이하</th>
            <td>5.50</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <th scope="row" rowspan="12">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">7 - 14 Days</th>
            <td>2.80%</td>
          </tr>
          <tr>
            <th scope="row">15 -30 Days</th>
            <td>3.00%</td>
          </tr>
          <tr>
            <th scope="row">31 - 45 Days</th>
            <td>4.00%</td>
          </tr>
          <tr>
            <th scope="row">46 - 60 Days</th>
            <td>4.00%</td>
          </tr>
          <tr>
            <th scope="row">61 - 91 Days</th>
            <td>4.25%</td>
          </tr>
          <tr>
            <th scope="row">92 - 182 Days</th>
            <td>4.50%</td>
          </tr>
          <tr>
            <th scope="row">183 - 273 Days</th>
            <td>4.50%</td>
          </tr>
          <tr>
            <th scope="row">274 Days - Less than 1 year</th>
            <td>4.75</td>
          </tr>
          <tr>
            <th scope="row">1 year - Less than 2 years</th>
            <td>5.25</td>
          </tr>
          <tr>
            <th scope="row">2 year - Less than 3 years</th>
            <td>5.50</td>
          </tr>
          <tr>
            <th scope="row">3 year - Less than 5 years</th>
            <td>5.50</td>
          </tr>
          <tr>
            <th scope="row">5 year - up to 10 years</th>
            <td>5.50</td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="cont-tit">
      <h6>
        {{ /*적금*/ $t("MDEP-02-01-01-04") }}
        <required />
      </h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type02">
      <colgroup>
        <col width="30%" />
        <col width="50%" />
        <col />
      </colgroup>
      <tbody>
        <template v-if="lnag == $config.LANG_KOR">
          <tr>
            <th scope="row" rowspan="4">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">6 개월 - 12 개월 미만</th>
            <td>5.00%</td>
          </tr>
          <tr>
            <th scope="row">12 개월 - 24 개월 미만</th>
            <td>5.25%</td>
          </tr>
          <tr>
            <th scope="row">24 개월 - 36 개월 미만</th>
            <td>5.50%</td>
          </tr>
          <tr>
            <th scope="row">36 개월 - 60 개월 이하</th>
            <td>5.50%</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <th scope="row" rowspan="4">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
            <th scope="row">6 Months to less than 12 months</th>
            <td>5.00%</td>
          </tr>
          <tr>
            <th scope="row">12 Months to less than 24 months</th>
            <td>5.25%</td>
          </tr>
          <tr>
            <th scope="row">24 Months to less than 36 months</th>
            <td>5.50%</td>
          </tr>
          <tr>
            <th scope="row">36 Months to 60 months</th>
            <td>5.50%</td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="cont-tit">
      <h6>
        {{ /*요구불예금*/ $t("MDEP-01-02-01-31") }}
        <required />
      </h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type02">
      <colgroup>
        <col width="50%" />
        <col width="50%" />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <td>3.50%</td>
        </tr>
      </tbody>
    </table>

    <div class="info info-type4">
      <p>※ {{ /*이자율은 인도 법률과 시장상황에 따라 수시로 바뀔 수 있습니다.*/ $t("MDEP-01-02-03-18") }}</p>
      <p>※ {{ /*금리 적용일*/ $t("MDEP-01-02-03-19") }} : 09.06.2020</p>
    </div>
  </div>
</template>
<script>
import Required from "@/components/template/Required";
import { mapFields } from "vuex-map-fields";
export default {
  components: { Required },
  computed: {
    ...mapFields(["lang"]),
  },
  data() {
    return {
      currentTab: 0,
    };
  },
};
</script>
